import {Row, Table} from "./generic/table";
import {TableOpts, TableResponse, TableRow, WithAPI} from "../api/temperature";
import {WithSensor} from "./pages/sensorDetail";
import {FetchProps, useFetchAndRender} from "./fetchAndRender";
import {DateTime} from "./generic/date";
import {Temperature} from "./generic/temperature";
import {Number} from "./generic/number";
import {ComponentChild, ComponentChildren} from "preact";

export type HistoryTableProps = {
    showSamples?: boolean;
    tableInterval?: string;
    expectedRows?: number;
    headerTitle?: string;
    headerFormatter?: (row: TableRow) => ComponentChildren;
} & WithAPI & WithSensor & FetchProps & Omit<TableOpts, "interval">;

export function HistoryTable(props: HistoryTableProps) {
    const {interval, ...propsWithoutInterval} = props;

    const [result] = useFetchAndRender<TableResponse>(() => props.api.table(
        props.sensor,
        Object.assign({interval: props.tableInterval}, propsWithoutInterval)
    ), {
        interval
    });

    const showSamples = props.showSamples ?? true;
    const expectedRows = Math.max(1, props.expectedRows ?? props.limit ?? 5);
    const headerFormatter = props.headerFormatter ?? (row => <><DateTime value={row.from} /> - <DateTime value={row.to} /></>);

    const generateEmptyRows = (numOfRows: number, colspan?: number) => {
        const out: ComponentChild[] = [];

        for (let i = 0; i < numOfRows; ++i) {
            out.push(<Row cells={{"header": <td>&nbsp;</td>}} />);
        }

        return out;
    }

    return <Table columns={[
        {id: "header", title: props.headerTitle ?? ""},
        {id: "min", title: "Min", class: "text-right td-shrink"},
        {id: "max", title: "Max", class: "text-right td-shrink"},
        {id: "avg", title: "Average", class: "text-right td-shrink"},
        {id: "samples", title: "Samples", visible: showSamples, class: "text-right td-shrink"},
    ]} footer={<tr>
        <td colspan={showSamples ? 5 : 4} class="text-right">
            {result && result.zDEBUG_execTime ? <small class="text-muted">Fetched in <Number value={result.zDEBUG_execTime} />s</small> : null}
        </td>
    </tr>}>{
        result ? result.table.map(row => <Row cells={{
            "header": <th>{headerFormatter(row)}</th>,
            "min": <td class="text-right"><Temperature value={row.min.value} /></td>,
            "max": <td class="text-right"><Temperature value={row.max.value} /></td>,
            "avg": <td class="text-right"><Temperature value={row.average} /></td>,
            "samples": <td class="text-right"><Number value={row.samples} /></td>,
        }} />) : <>
            <Row cells={{
                "header": <th>Loading...</th>
            }} />
            {generateEmptyRows(expectedRows - 1)}
        </>
    }</Table>;
}
